module.exports = __webpack_public_path__ + "img/logo-botri.44b2663a.png";